import { el, setStyle } from 'redom';

import ToggleInput from 'generics/components/toggle-input';
import SingleSelectInputBox from 'generics/components/single-select/native/input-box';
import CSSNumberValueControl from 'generics/components/css-number-value-control/native';

import './index.scss';

const POSITION_OPTIONS = [{
  label: 'Top',
  value: 'top'
}, {
  label: 'Bottom',
  value: 'bottom'
}];

const APPEARANCE_OPTIONS = [{
  label: 'Static',
  value: 'static'
}, {
  label: 'Hover',
  value: 'hover'
}];

function getOptionIndex(options, value) {

  for (let index = 0; index < options.length; index++) {

    if (options[index].value === value) {
      return index;
    }

  }

  return 0;

}

class GallerySettings {

  constructor(configuration) {

    this.onChange = configuration.onChange;
    this.settings = { ...configuration.settings };

    this.buildCaptionToggle();
    this.buildColumnsInput();
    this.buildColumnSpacingInput();
    this.buildRowSpacingInput();
    this.buildFullViewToggle();
    this.buildCaptionPositionSelect();
    this.buildCaptionAppearanceSelect();

    this.captionSubSettings = el('.gallery-settings-caption-subsettings', [
      this.buildRow('Caption position', this.captionPositionSelect),
      this.buildRow('Caption appearance', this.captionAppearanceSelect)
    ]);

    this.el = el('.gallery-settings-main', [
      this.buildRow('Columns', this.columnsInput),
      this.buildRow('Column spacing', this.columnSpacingInput),
      this.buildRow('Row spacing', this.rowSpacingInput),
      this.buildRow('Full view on click', this.fullViewToggle, '.toggle-row'),
      this.buildRow('Captions', this.captionToggle, '.toggle-row'),
      this.captionSubSettings
    ]);

    this.applyCaptionVisibility();

  }

  buildRow(labelText, controlElement, cls = '') {

    return el('.gallery-settings-row' + cls, [
      el('label.gallery-settings-label.field-label', labelText),
      controlElement
    ]);

  }

  buildCaptionToggle() {

    this.captionToggle = new ToggleInput({
      on: true,
      off: false,
      value: this.settings.captionEnabled,
      onChange: this.handleCaptionToggleChange.bind(this)
    });

  }

  buildFullViewToggle() {

    this.fullViewToggle = new ToggleInput({
      on: true,
      off: false,
      value: this.settings.fullViewEnabled,
      onChange: this.handleFullViewChange.bind(this)
    });

  }

  buildColumnsInput() {

    const valueControlProperties = {
      value: this.settings.columns,
      onChange: (value) => this.handleColumnsChange(parseInt(value, 10))
    };

    this.columnsInput = new CSSNumberValueControl(valueControlProperties);

  }

  buildColumnSpacingInput() {

    const valueControlProperties = {
      value: this.settings.columnSpacing,
      onChange: (value) => this.handleColumnSpacingChange(parseInt(value, 10))
    };

    this.columnSpacingInput = new CSSNumberValueControl(valueControlProperties);

  }

  buildRowSpacingInput() {

    const valueControlProperties = {
      value: this.settings.rowSpacing,
      onChange: (value) => this.handleRowSpacingChange(parseInt(value, 10))
    };

    this.rowSpacingInput = new CSSNumberValueControl(valueControlProperties);

  }

  buildCaptionPositionSelect() {

    this.captionPositionSelect = new SingleSelectInputBox({
      placeholder: 'Select position',
      options: POSITION_OPTIONS,
      selectedOptionIndices: [getOptionIndex(POSITION_OPTIONS, this.settings.captionPosition)],
      onChange: this.handleCaptionPositionChange.bind(this)
    });

  }

  buildCaptionAppearanceSelect() {

    this.captionAppearanceSelect = new SingleSelectInputBox({
      placeholder: 'Select appearance',
      options: APPEARANCE_OPTIONS,
      selectedOptionIndices: [getOptionIndex(APPEARANCE_OPTIONS, this.settings.captionAppearance)],
      onChange: this.handleCaptionAppearanceChange.bind(this)
    });

  }

  handleCaptionToggleChange(value) {

    this.settings.captionEnabled = value;

    this.applyCaptionVisibility();
    this.propagateChange();

  }

  handleFullViewChange(value) {

    this.settings.fullViewEnabled = value;
    this.propagateChange();

  }

  handleColumnsChange(value) {

    if (isNaN(value) === true) {
      return;
    }

    if (value < 1 || value > 10) {
      return;
    }

    this.settings.columns = value;
    this.propagateChange();

  }

  handleColumnSpacingChange(value) {

    if (isNaN(value) === true) {
      return;
    }

    if (value < 0) {
      return;
    }

    this.settings.columnSpacing = value;
    this.propagateChange();

  }

  handleRowSpacingChange(value) {

    if (isNaN(value) === true) {
      return;
    }

    if (value < 0) {
      return;
    }

    this.settings.rowSpacing = value;
    this.propagateChange();

  }

  handleCaptionPositionChange(selection) {

    this.settings.captionPosition = selection.values[0];
    this.propagateChange();

  }

  handleCaptionAppearanceChange(selection) {

    this.settings.captionAppearance = selection.values[0];
    this.propagateChange();

  }

  applyCaptionVisibility() {

    if (this.settings.captionEnabled === true) {
      setStyle(this.captionSubSettings, { display: '' });
      return;
    }

    setStyle(this.captionSubSettings, { display: 'none' });

  }

  propagateChange() {

    this.onChange({ ...this.settings });

  }

}

export default GallerySettings;